import AbstractProductType from './AbstractProductType'
import { ProductTypeFormat } from './types'

export default class ValetCurbside extends AbstractProductType {

  name = 'valet_curbside'
  title = 'Valet Curbside'

  curbside = true
  valet = true
  format = ProductTypeFormat.Uncovered

}
